import {Component} from 'react';
import Button from 'react-bootstrap/Button';
import '../../../css/styles.css';
import SavingsPolicyOptions from './datasets/savings_policy_options';
import { doubleToStringMonthly, standardNumberFormat } from '../../../objects/CommonUse/double_functions';
import reformatDateToDisplay from '../../../objects/CommonUse/reformatDateToDisplay_function';

class SetupSavingsCardDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
           rerender: false,
        }
        this.savingsPolicyData = SavingsPolicyOptions;
        this.displayInfo = false;
        this.initializeDisplayInfo();
    }

    initializeDisplayInfo(){
        if (this.props.savingsInfo.startDate === ""){
            this.displayInfo = true;
        }
    }

    initializeSavingsData(){
        this.savingsData = 
            this.savingsPolicyData.find(elem => elem.type === this.props.savingsInfo.savingsType);
        this.featuresList = this.savingsData.featuresArr.join(', ');
        this.imageURL = this.savingsData.imageUrl;
    }

    toggleInfoDisplay(){
        this.displayInfo = !this.displayInfo
        this.setState({rerender: !this.state.rerender})
    }

    render() {
       this.initializeSavingsData();
       if (this.props.savingsInfo.startDate === ""){
            this.startDate = "Not Opened";
       }else{
            this.startDate = reformatDateToDisplay(this.props.savingsInfo.startDate);
       }
       if (this.props.savingsInfo.savingsType === "CD"){
            if (this.props.savingsInfo.autoRollover === true){
                this.autoRollover = "Yes";
            }else{
                this.autoRollover = "No";
            }
       }
       const companyMatchRate = +this.props.savingsInfo.companyMatchRate * 100;
       const defaultImgSrc = "./assets/Savings/" + this.imageURL;
       this.totalTransferAmt = +this.props.savingsInfo.prevTransferAmt + +this.props.savingsInfo.newTransferAmt;
           
    return <>
      
        <div className="flex-grow-1">
            <div className="mx-4"><b>What is a {this.savingsData.longName}?&nbsp;&nbsp;</b>
                {this.displayInfo ? (
                    <div className="mt-2 text-left">  
                        {this.savingsData.description}
                         <div>
                            <b>Features: </b>{this.featuresList}
                            <Button  className="ml-2" variant="outline-info"  size="sm"
                                onClick={() => this.toggleInfoDisplay("collapse")}>
                                    Collapse
                            </Button>
                        </div>
                    </div>
                ) : (
                    <span className="p-0 text-right">
                        <Button variant="outline-info" size="sm"
                            onClick={() => this.toggleInfoDisplay("expand")} >
                            Learn More
                        </Button>
                    </span>
                )}
            </div>
             <div className="row">
                <div className="col-sm-2">
                        <img src={defaultImgSrc} className="card_size_thumbnail_smaller_img" alt="logo" />
                </div>
                <div className="col-sm-10">
                    {this.props.savingsClass === "bank"  ?
                        <>
                        {this.props.callingProcess !== "modal"  ?
                        <>
                            <div className="row">
                                {this.props.savingsInfo.startDate !== "" ?
                                    <div className="col-sm-6">
                                        <span className="font-weight-bold">Current Account Balance: </span>
                                        <span className="ml-2">
                                            {doubleToStringMonthly(this.props.savingsInfo.totalSavingsAmt)}
                                        </span> 
                                    </div>
                                :
                                    <div className="col-sm-6 ">
                                        <span className="font-weight-bold">Interest Rate: </span>
                                        <span className="ml-2">{this.props.savingsInfo.intRate}%</span>
                                    </div>
                                }
                                <div className="col-sm-6 text-left">
                                    <span className="font-weight-bold">Game Date: </span>
                                    <span className="ml-2">{reformatDateToDisplay(this.props.currentGameDate)}
                                        </span>
                                </div>
                            </div>
                        </>
                        :
                            null
                        }
                    </>
                    :
                        <div className="row">
                            <div className="col-sm-6 text-left">
                                <span className="font-weight-bold">Company Match:</span>
                                <span className="ml-2">{companyMatchRate}%</span>
                            </div>
                            {this.props.savingsInfo.depositPercent > 0   ?
                                <div className="col-sm-6 text-left">
                                    <span className="font-weight-bold">Monthly Percent: </span>
                                    <span className="ml-2">{standardNumberFormat(this.props.savingsInfo.depositPercent)}%
                                        </span>
                                </div>
                            :
                                null
                            }
                        </div>
                    }
                            
                    {this.props.savingsInfo.startDate === "" ?
                        null
                    :
                        <>
                            {this.props.callingProcess === "modal"  ?
                            <>
                                <div className="row">
                                        <div className="col-sm-6">
                                            <span className="font-weight-bold">Total Deposited:</span>
                                            <span className="ml-2">
                                                {doubleToStringMonthly(this.props.savingsInfo.totalDeposited)}
                                            </span>
                                        </div>
                                        <div className="col-sm-6">
                                            <span className="font-weight-bold">Game Date:</span>
                                            <span className="ml-2">
                                                {reformatDateToDisplay(this.props.currentGameDate)}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-6">
                                            <span className="font-weight-bold">Total Withdrawals:</span>
                                            <span className="ml-2">
                                                {doubleToStringMonthly(this.totalTransferAmt)}
                                            </span>
                                        </div>
                                        <div className="col-sm-6">
                                            <span className="font-weight-bold">Account Opened:</span>
                                            <span className="ml-2">{this.startDate}</span>
                                        </div>
                                    </div>

                                    {this.props.savingsClass === "bank"  ?
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <span className="font-weight-bold">Total Interest Earned:</span>
                                                <span className="ml-2">
                                                    {doubleToStringMonthly(this.props.savingsInfo.intEarned)}
                                                </span>
                                            </div>
                                            <div className="col-sm-6">
                                                <span className="font-weight-bold">Interest Rate:</span>
                                                <span className="ml-2">{this.props.savingsInfo.intRate}%</span>
                                            </div>
                                        </div>
                                    :
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <span className="font-weight-bold">Total Nbr Shares:</span>
                                                <span className="ml-2">
                                                    {this.props.savingsInfo.quantity}
                                                </span>
                                            </div>
                                            <div className="col-sm-6">
                                                <span className="font-weight-bold">Current Price:</span>
                                                <span className="ml-2">
                                                    {doubleToStringMonthly(this.props.savingsInfo.currentPrice)}</span>
                                            </div>
                                        </div>
                                    }
                                                                            
                               
                            </>
                            :
                                null
                            }
                                
                        </>
                    }

                    <div className="row">
                        <div className="col-sm-6 text-left">
                            <span className="font-weight-bold">Total in Account:</span>
                            <span className="ml-2">
                                {doubleToStringMonthly(this.props.savingsInfo.totalSavingsAmt)}
                            </span>
                        </div>
                        {this.props.savingsInfo.savingsType !== "CD" ?
                            <div className="col-sm-6 text-left">
                                <span className="font-weight-bold">Current Monthly Amt:</span>
                                <span className="ml-2">
                                    {doubleToStringMonthly(this.props.savingsInfo.currentMonthlyAmt)}
                                </span>
                            </div>
                        :
                            null
                        }
                    </div>
                    {this.props.savingsInfo.oneTimeDepositAmt !== 0 ||
                            this.props.savingsInfo.monthlyDepositAmt !== 0  ?
                            <div className="row ">
                                <div className="col-sm-6 text-left">
                                    <span className="font-weight-bold">One Time Amount: </span>
                                    <span className="ml-2">
                                        {doubleToStringMonthly(this.props.savingsInfo.oneTimeDepositAmt)}
                                    </span>
                                </div>
                                {this.props.savingsInfo.savingsType !== "CD" ?
                                    <div className="col-sm-6 text-left">
                                        <span className="font-weight-bold">New Monthly Amt: </span>
                                        <span className="ml-2">
                                            {doubleToStringMonthly(this.props.savingsInfo.monthlyDepositAmt)}
                                        </span>
                                    </div>
                                :
                                    null
                                }
                            </div>
                        :
                            null
                        }

                </div>
                
                    {this.props.callingProcess === "modal"  ?
                        <>
                            {this.props.savingsInfo.savingsType === "CD" ?
                                <div className="ml-4">
                                    *** No fees are charged for CD Withdrawals if they are done in same 
                                    month/year that CD matures.
                                </div>
                            :
                                null
                            }
                        </>
                    :
                        null
                    }
            </div>
       
        </div>
   
    </>
    }


}

export default SetupSavingsCardDisplay;